import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search.png'
import _imports_1 from '@/assets/images/title1.png'
import _imports_2 from '@/assets/images/category1c.png'
import _imports_3 from '@/assets/images/category1.png'
import _imports_4 from '@/assets/images/category2c.png'
import _imports_5 from '@/assets/images/category2.png'
import _imports_6 from '@/assets/images/category3c.png'
import _imports_7 from '@/assets/images/category3.png'
import _imports_8 from '@/assets/images/category4c.png'
import _imports_9 from '@/assets/images/category4.png'
import _imports_10 from '@/assets/images/category5c.png'
import _imports_11 from '@/assets/images/category5.png'
import _imports_12 from '@/assets/images/category6c.png'
import _imports_13 from '@/assets/images/category6.png'
import _imports_14 from '@/assets/images/category7c.png'
import _imports_15 from '@/assets/images/category7.png'
import _imports_16 from '@/assets/images/company.png'
import _imports_17 from '@/assets/images/intelligent.png'
import _imports_18 from '@/assets/images/function6.png'
import _imports_19 from '@/assets/images/function5.png'
import _imports_20 from '@/assets/images/function1.png'
import _imports_21 from '@/assets/images/function2.png'
import _imports_22 from '@/assets/images/function3.png'
import _imports_23 from '@/assets/images/function4.png'
import _imports_24 from '@/assets/images/zc.png'
import _imports_25 from '@/assets/images/xy.png'
import _imports_26 from '@/assets/images/category8c.png'
import _imports_27 from '@/assets/images/category8.png'
import _imports_28 from '@/assets/images/category9c.png'
import _imports_29 from '@/assets/images/category9.png'
import _imports_30 from '@/assets/images/category10c.png'
import _imports_31 from '@/assets/images/category10.png'
import _imports_32 from '@/assets/images/clock.png'
import _imports_33 from '@/assets/images/zx1.png'


const _withScopeId = n => (_pushScopeId("data-v-3996bc3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: "site-home",
  style: {"background":"#fff"}
}
const _hoisted_2 = { class: "site-home-nav" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-middle-auto banner-1" }, [
    /*#__PURE__*/_createTextVNode(" 公共资源交易中心 "),
    /*#__PURE__*/_createElementVNode("div", null, "电子交易平台开发单位")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-middle-auto banner-6" }, [
    /*#__PURE__*/_createTextVNode(" 首个直连安徽省公共资源交易中心、省 "),
    /*#__PURE__*/_createElementVNode("div", null, "级政府采购平台（安徽省徽采云）的第三方"),
    /*#__PURE__*/_createTextVNode(" 电子交易平台 ")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-middle-auto banner-2" }, [
    /*#__PURE__*/_createTextVNode(" 全国"),
    /*#__PURE__*/_createElementVNode("span", null, "前十名"),
    /*#__PURE__*/_createElementVNode("div", null, "第三方交易平台推送国家公共服务平台累计项目数"),
    /*#__PURE__*/_createElementVNode("div", null, "量全国前十名")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-middle-auto banner-4" }, [
    /*#__PURE__*/_createTextVNode(" 依托专业招标代理咨询能力， "),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("创新推出 "),
      /*#__PURE__*/_createElementVNode("span", null, "AI招采平台")
    ])
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-middle-auto banner-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "banner-title" }, [
      /*#__PURE__*/_createTextVNode(" 平台"),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"600","color":"#ff7d89"} }, "日均"),
      /*#__PURE__*/_createTextVNode("承载 ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "banner-num" }, [
      /*#__PURE__*/_createTextVNode(" 项目"),
      /*#__PURE__*/_createElementVNode("span", { class: "num" }, "500+"),
      /*#__PURE__*/_createTextVNode("访问量"),
      /*#__PURE__*/_createElementVNode("span", { class: "num" }, "3w+")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "banner-desc" }, "运营规模稳居行业前列")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav-banner nav-banner5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "site-middle-auto banner-5" }, [
    /*#__PURE__*/_createTextVNode(" 国家"),
    /*#__PURE__*/_createElementVNode("span", null, "首批"),
    /*#__PURE__*/_createTextVNode("电子招标投标 "),
    /*#__PURE__*/_createElementVNode("div", null, "交易平台试点单位")
  ])
], -1))
const _hoisted_9 = { class: "card-container site-middle-auto" }
const _hoisted_10 = { class: "search-container" }
const _hoisted_11 = { class: "addon-before" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "search-icon",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_13 = { class: "zb-right" }
const _hoisted_14 = { class: "login-container" }
const _hoisted_15 = { class: "login-top" }
const _hoisted_16 = {
  key: 0,
  class: "login-content"
}
const _hoisted_17 = { class: "login-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-user" }, null, -1))
const _hoisted_19 = { class: "login-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-2" }, "登录后查看专属服务内容", -1))
const _hoisted_21 = { class: "handle-btns" }
const _hoisted_22 = { style: {"text-align":"center"} }
const _hoisted_23 = {
  key: 1,
  class: "login-content"
}
const _hoisted_24 = { class: "logined" }
const _hoisted_25 = { class: "login-0" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-user" }, null, -1))
const _hoisted_27 = { class: "login-1" }
const _hoisted_28 = { class: "login-2" }
const _hoisted_29 = { style: {"text-align":"center"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "我的项目", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://file.youzhicai.com/files/BidderHelp.rar",
  download: ""
}, "投标指南", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://toolcdn.youzhicai.com/tools/BidderTools.zip",
  download: ""
}, " 投标文件编制工具 ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "企业案例", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://toolcdn.youzhicai.com/ca.zip",
  download: ""
}, "数字证书助手", -1))
const _hoisted_35 = { class: "site-statistics" }
const _hoisted_36 = { class: "site-middle-auto" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "平台项目数 (个)", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "成交总额数（亿元）", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " +", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "供应商数 (个)", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics-desc" }, [
  /*#__PURE__*/_createTextVNode(" — 平台近 "),
  /*#__PURE__*/_createElementVNode("span", null, "10年"),
  /*#__PURE__*/_createTextVNode(" 来累计项目数量和成交金额 ")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zb-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_43 = { class: "zb-container site-notice" }
const _hoisted_44 = { class: "site-middle-auto zb-wrap" }
const _hoisted_45 = { class: "zb-zone" }
const _hoisted_46 = { class: "tab-title" }
const _hoisted_47 = {
  key: 0,
  src: _imports_2
}
const _hoisted_48 = {
  key: 1,
  src: _imports_3
}
const _hoisted_49 = {
  key: 0,
  src: _imports_4
}
const _hoisted_50 = {
  key: 1,
  src: _imports_5
}
const _hoisted_51 = {
  key: 0,
  src: _imports_6
}
const _hoisted_52 = {
  key: 1,
  src: _imports_7
}
const _hoisted_53 = {
  key: 0,
  src: _imports_8
}
const _hoisted_54 = {
  key: 1,
  src: _imports_9
}
const _hoisted_55 = {
  key: 0,
  src: _imports_10
}
const _hoisted_56 = {
  key: 1,
  src: _imports_11
}
const _hoisted_57 = {
  key: 0,
  src: _imports_12
}
const _hoisted_58 = {
  key: 1,
  src: _imports_13
}
const _hoisted_59 = {
  key: 0,
  src: _imports_14
}
const _hoisted_60 = {
  key: 1,
  src: _imports_15
}
const _hoisted_61 = { class: "zb-content" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 0,
  class: "label"
}
const _hoisted_64 = { class: "zb-content-item-left" }
const _hoisted_65 = ["title"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_67 = { class: "zb-content-item-right" }
const _hoisted_68 = {
  key: 0,
  class: "over-time"
}
const _hoisted_69 = {
  key: 1,
  class: "durations-content"
}
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { style: {"color":"#646a73"} }
const _hoisted_72 = { class: "durations-time font-22" }
const _hoisted_73 = { class: "durations-time" }
const _hoisted_74 = { class: "durations-time" }
const _hoisted_75 = {
  key: 1,
  class: "release-time"
}
const _hoisted_76 = { class: "release-day" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_78 = { class: "release-year-month" }
const _hoisted_79 = { class: "view-more" }
const _hoisted_80 = { class: "intelligent-container site-margin-auto" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intelligent-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_17,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_82 = { class: "site-middle-auto intelligent-wrap" }
const _hoisted_83 = { class: "intelligent-left" }
const _hoisted_84 = { class: "intelligent-card1" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "全流程电子招投标交易系统", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_87 = { class: "intelligent-card2" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "智云医采", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_91 = { class: "intelligent-right" }
const _hoisted_92 = { class: "intelligent-right-item" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_20 }, null, -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fuc-name" }, "智能辅助评审系统", -1))
const _hoisted_95 = { class: "intelligent-right-item" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_21 }, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fuc-name" }, "采购人项目管理平台", -1))
const _hoisted_98 = { class: "intelligent-right-item" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_22 }, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fuc-name" }, "电子招投标专项工具", -1))
const _hoisted_101 = { class: "intelligent-right-item" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_23 }, null, -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fuc-name" }, "AI招标采购知识大模型", -1))
const _hoisted_104 = { class: "zc-container" }
const _hoisted_105 = { class: "site-middle-auto zc-wrap" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zc-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_24,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_107 = { class: "zc-tab" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = {
  key: 0,
  class: "label"
}
const _hoisted_110 = ["title"]
const _hoisted_111 = {
  key: 1,
  class: "time-box"
}
const _hoisted_112 = { class: "time" }
const _hoisted_113 = { class: "durations-time" }
const _hoisted_114 = { class: "durations-time" }
const _hoisted_115 = ["onClick"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "我要参与")
], -1))
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = {
  key: 2,
  class: "time-status"
}
const _hoisted_119 = { class: "view-more" }
const _hoisted_120 = { class: "xy-container" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xy-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_25,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_122 = { class: "site-middle-auto xy-wrap" }
const _hoisted_123 = { class: "xy-zone" }
const _hoisted_124 = { class: "tab-title" }
const _hoisted_125 = {
  key: 0,
  src: _imports_26
}
const _hoisted_126 = {
  key: 1,
  src: _imports_27
}
const _hoisted_127 = {
  key: 0,
  src: _imports_10
}
const _hoisted_128 = {
  key: 1,
  src: _imports_11
}
const _hoisted_129 = {
  key: 0,
  src: _imports_12
}
const _hoisted_130 = {
  key: 1,
  src: _imports_13
}
const _hoisted_131 = {
  key: 0,
  src: _imports_28
}
const _hoisted_132 = {
  key: 1,
  src: _imports_29
}
const _hoisted_133 = {
  key: 0,
  src: _imports_30
}
const _hoisted_134 = {
  key: 1,
  src: _imports_31
}
const _hoisted_135 = { class: "xy-content-list" }
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 0,
  class: "label"
}
const _hoisted_138 = ["title"]
const _hoisted_139 = {
  key: 1,
  class: "time-box"
}
const _hoisted_140 = { class: "time" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_32,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_142 = { class: "durations-time" }
const _hoisted_143 = { class: "durations-time" }
const _hoisted_144 = ["onClick"]
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "我要参与")
], -1))
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = {
  key: 2,
  class: "time-status"
}
const _hoisted_148 = { class: "view-more" }
const _hoisted_149 = ["href"]
const _hoisted_150 = { class: "supplier-container zx-container" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zx-title" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_33,
      alt: "",
      srcset: ""
    })
  ])
], -1))
const _hoisted_152 = { class: "site-middle-auto zx-warp" }
const _hoisted_153 = { class: "zx-list" }
const _hoisted_154 = { class: "body" }
const _hoisted_155 = ["onClick"]
const _hoisted_156 = ["title"]
const _hoisted_157 = { class: "zx-list" }
const _hoisted_158 = { class: "body" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = ["title"]

import {
  defineAsyncComponent,
  onMounted,
  onBeforeUnmount,
  ref,
  shallowRef,
} from "vue";
import AppHeader from "@/layout/components/app-header.vue";
import dayjs from "dayjs";
import { useRouteHopping } from "@/utils/use-route-to";
import useDownload from "@/utils/use-download";
import {
  zbcgList,
  zfcgList,
  getBidderCount,
  getTenderCount,
  getProjectCount,
  getAmountCount,
  getActiveBidder,
  newsListPage,
  zhcgList,
  yjsort,
  getMenuPermissionsByPath,
  specialSearch,
  checkLogin,
  checkToBid,
  getWebsitePlatform,
} from "@/api/site-home/index";
import { Modal } from "ant-design-vue";
import { useBaiduTongji } from "@/utils/use-baidutongji";
import { useUserStore } from "@/store/modules/user/index";
import { useRouter } from "vue-router";

import { defineComponent } from "vue";
import { errorInfoDis } from "@/utils/project-utils";
import { setDocumentTitle } from "@/utils/document-title-utils";

const __default__ = defineComponent({
  name: "SiteHome",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

useBaiduTongji("");

const ContactUs = defineAsyncComponent(
  () => import("./components/contact-us.vue")
);
const NoPermission = defineAsyncComponent(
  () => import("./components/no-permission.vue")
);
const userStore = useUserStore();
const { currentRoute } = useRouter();
const loginUrl = `${
  process.env.VUE_APP_DOMAIN
}/sso-cross-api/router/relogin/yzczb?url=${encodeURIComponent(
  window.location.href
)}`;
const regUrl = `${process.env.VUE_APP_LOGIN_DOMANI}/homeweb/#/register`;
const searchVal = shallowRef<string>();
const contactVisible = shallowRef<boolean>(false);
const bidderCount = shallowRef<number>(0);
const tenderCount = shallowRef<number>(0);
const projectCount = shallowRef<number>(0);
const amountCount = shallowRef<number>(0);
const activeKey = shallowRef<string>("2");
const zhcgKey = shallowRef<string>("2");
const govKey = shallowRef<number>(2);
const zbcgData = shallowRef<any[]>([]);
const zcfgData = shallowRef<any[]>([]);
const zhcgData = shallowRef<any[]>([]);
const hyzxData = shallowRef<any[]>([]);
const data = shallowRef<any[]>([]);
const activeBidData = shallowRef<any[]>([]);
const yjSortData = shallowRef<any[]>([]);
const companySiteUrl =
  process.env.VUE_APP_ENV === "production"
    ? "https://hssx.yzczb.com/"
    : "https://hssx.zhiyunshang.com.cn/";

const text1 =
  "优质采招标采购平台基于招标集团三十多年的行业积累与实践经验，依托法律法规，深度融合招标采购、政府采购及寻源快采等多种业务场景，构建了全流程电子化、数字化与智能化的招标采购平台。平台有效应对传统招标采购中存在的效率低下、操作不透明、合规风险高等痛点，结合人工智能与大数据等前沿技术，打造以AI驱动的新一代智能招标采购新范式，全面提升采购效能与管理水平。";
const text2 =
  "智云医采是专为医疗行业打造的智能采购决策系统，基于海量医疗设备参数与价格数据库，为医疗机构、代理机构提供精准的采购决策支持。系统实现CT、超声多普勒等设备的价格趋势一键查询、参数智能匹配和最优方案推荐，帮助用户快速掌握市场行情、科学制定预算。同时支持一键生成包含历史规格、价格趋势的详细分析报告，有效解决医疗采购中参数不清晰、价格不透明等痛点，让医疗设备采购更精准高效。";
const text3 =
  "系统基于智云优采大模型技术，为招投标评审提供智能化解决方案。系统采用“类人”级智能评审技术，实现90%准确的客观分评审，自动显示评审结果及依据；通过投标文件结构化处理、章节自动关联和页码精准定位，评审效率提升40%；同时支持AI智能建议与专家复核相结合的人机协同模式，确保评审权威性。该系统覆盖从符合性检查到客观分评定的全流程，使复杂评审工作更简单高效，为招投标提供智能化支撑。";
const text4 =
  "采购人一体化项目监管与管理系统，深度融合多年招标代理服务经验与技术积累，精准应对采购项目数量庞大、采购主体众多、外部监管要求不断提高等核心痛点。系统将招标采购全流程解构为4大阶段、14个标准化环节，实现信息一次录入、流程自动驱动与多部门在线协同。支持采购人与代理机构高效交互，一键生成智能分析报告，并赋能管理部门实时在线监督，全面提升采购管理的规范化、透明化、智能化及整体协同效率。";
const text5 =
  "系统 以 “安全可控・智能高效” 为核心主题，秉持“全程可控，密不外传”原则。支持局域网评标，保障数据安全；具备价格自动算分等自动化功能，提升评标效率；同时实现招标至评标全流程电子留痕与归档，便于资料管理。";
const text6 =
  "招采智能问答系统基于AI大模型与虚拟人技术，整合54万+政策法规构建专业知识库，并依托招投标行业垂直模型实现精准语义解析。系统面向代理机构、招标人及评标专家，提供覆盖全流程的智能咨询服务，具备多轮对话与案例推理能力，通过虚拟人交互实现复杂问题的秒级响应，显著提升用户政策理解与实务操作效率。";
const getCurrentTimePeriod = () => {
  const now = new Date();
  const hour = now.getHours();

  if (hour >= 0 && hour < 12) {
    return "上 午 好";
  } else if (hour >= 12 && hour < 18) {
    return "下 午 好";
  } else {
    return "晚 上 好";
  }
};
const registerHandle = () => {
  if (roleTabKey.value === 1) {
    window.location.href = regUrl;
  } else if (roleTabKey.value === 2) {
    contactVisible.value = true;
  }
};
const loginHandle = () => {
  window.location.href = loginUrl;
};

const toToBidder = async (info: any) => {
  try {
    if (!info.sectionSourceId) {
      return errorInfoDis("缺失标段ID");
    }
    const res = await checkLogin();
    if (!res) {
      Modal.destroyAll();
      Modal.info({
        title: "系统提示",
        content: "登录状态已过期，请退出重新登录！",
        okText: "重新登录",
        onOk: () => {
          const loginUrl = `${
            process.env.VUE_APP_DOMAIN
          }/sso-cross-api/router/relogin/yzczb?url=${encodeURIComponent(
            window.location.href
          )}`;
          location.replace(loginUrl);
        },
      });
      return false;
    }
    if (!info.sid) {
      errorInfoDis("缺失ID");
      return false;
    }
    const bidRes = await checkToBid({ sid: info.sid });
    if (!bidRes) {
      errorInfoDis("当前项目不可报名!");
      return false;
    }
    const url = await getWebsitePlatform({ id: info.id });
    window.open(url.bidUrl, "_blank");
  } catch (error: any) {
    return errorInfoDis(error.message || "校验失败");
  }
};
const checkGovNav = (val: number) => {
  govKey.value = val;
  queryZfcgList(val);
};
const roleTabKey = ref<number>(1);
const changeLoginTab = (key: number) => {
  if (roleTabKey.value === key) return;

  if (userStore.userName && key === 1 && !userStore.userRole.includes(3)) {
    permissionVisible.value = true;
    return;
  } else if (
    userStore.userName &&
    key === 2 &&
    !userStore.userRole.includes(2) &&
    !userStore.userRole.includes(1)
  ) {
    permissionVisible.value = true;
    return;
  }
  roleTabKey.value = key;
};
const searchType = shallowRef<number>(1);
const goSearchResult = () => {
  // useRouteHopping("/site-search", {
  //   name: searchVal.value,
  // });
  if (searchVal.value) {
    useRouteHopping("/site-search", {
      searchType: searchType.value,
      name: searchVal.value,
    });
  } else {
    useRouteHopping("/site-search", {
      searchType: searchType.value,
    });
    userStore.setMenuKey(`/site-search`);
  }
};
// const toNewsListPage = (key: string) => {
//   userStore.setMenuKey(key);
//   useRouteHopping(key);
// };
const toSearch = (pType: number) => {
  let bType: undefined | number = undefined;
  if (pType === 1) {
    // 招标采购
    bType = Number(activeKey.value);
  } else if (pType === 2) {
    // 政府采购
    bType = govKey.value;
  } else if (pType === 3) {
    // 寻源快采
    bType = Number(zhcgKey.value);
  }
  userStore.setMenuKey(`/site-search?pType=${pType}`);
  useRouteHopping("/site-search", {
    pType,
    bType,
  });
};
const jumpUserManage = (activeKeyHome?: string) => {
  if (!activeKeyHome) {
    if (roleTabKey.value === 1) {
      window.open(`${process.env.VUE_APP_DOMAIN}/portal-bidder/`);
    } else {
      if (
        userStore.userRole.includes(2) ||
        (userStore.userRole.includes(1) && userStore.userRole.includes(2))
      ) {
        window.open(`${process.env.VUE_APP_DOMAIN}/portal-agency/`);
      } else if (userStore.userRole.includes(1)) {
        window.open(`${process.env.VUE_APP_DOMAIN}/portal-tender/`);
      } else {
        permissionVisible.value = true;
      }
    }
  } else {
    const list = menuRoleList.value.filter((item: any) => {
      return (
        item.menuPath === "/project-manage/simple/tender-project" &&
        item.subjectRoles.includes(1)
      );
    });
    const list2 = menuRoleList.value.filter((item: any) => {
      return (
        item.menuPath === "/project-manage/simple/tender-project" &&
        item.subjectRoles.includes(2)
      );
    });
    if (list2?.length) {
      window.open(
        `${process.env.VUE_APP_DOMAIN}/portal-agency/project-manage/simple/tender-project`
      );
    } else if (list?.length) {
      window.open(
        `${process.env.VUE_APP_DOMAIN}/portal-tender/project-manage/simple/tender-project`
      );
    } else {
      permissionVisible.value = true;
    }
  }
};
const permissionVisible = shallowRef<boolean>(false);
const jumpMyProject = () => {
  const list = menuRoleList.value.filter((item: any) => {
    return (
      item.menuPath === "/project-manage/project" &&
      item.subjectRoles.includes(3)
    );
  });
  if (list?.length) {
    window.open(
      `${process.env.VUE_APP_DOMAIN}/portal-bidder/project-manage/project`
    );
  } else {
    permissionVisible.value = true;
  }
};
const jumpSupplierLibrary = () => {
  const list = menuRoleList.value.filter((item: any) => {
    return (
      item.menuPath === "/supplier-library" && item.subjectRoles.includes(1)
    );
  });
  const list2 = menuRoleList.value.filter((item: any) => {
    return (
      item.menuPath === "/supplier-library" && item.subjectRoles.includes(2)
    );
  });
  if (list2?.length) {
    window.open(`${process.env.VUE_APP_DOMAIN}/portal-agency/supplier-library`);
  } else if (list?.length) {
    window.open(`${process.env.VUE_APP_DOMAIN}/portal-tender/supplier-library`);
  } else {
    permissionVisible.value = true;
  }
};
const downloadRegisterGuide = () => {
  useDownload(
    "https://www.youzhicai.com/Files/%E4%BC%98%E8%B4%A8%E9%87%87%E4%BA%91%E9%87%87%E8%B4%AD%E5%B9%B3%E5%8F%B0%E6%B3%A8%E5%86%8C%E6%8C%87%E5%AF%BC230811.pdf"
  );
};
const toDetail = (id: string) => {
  if (!id) {
    errorInfoDis("缺失公告ID");
    return false;
  }
  window.open(`/bultin-detail/${id}-1.html`);
};
const toDetailNews = (id: string) => {
  // useRouteParam("SiteNews", {
  //   id: `${id}.html`,
  // });
  window.open(`/site-news/${id}.html`);
};
const queryBidCount = async () => {
  try {
    const res = await getBidderCount();
    bidderCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询投标人数量失败");
  }
};
const queryTendCount = async () => {
  try {
    const res = await getTenderCount();
    tenderCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询招标人数量失败");
  }
};
const queryProjectCount = async () => {
  try {
    const res = await getProjectCount();
    projectCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询平台项目数失败");
  }
};
const queryAmountCount = async () => {
  try {
    const res = await getAmountCount();
    amountCount.value = res || 0;
  } catch (error: any) {
    errorInfoDis(error.message || "查询成交总金额失败");
  }
};
const queryActiveBidder = async () => {
  try {
    const res = await getActiveBidder();
    activeBidData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询活跃投标人列表失败");
  }
};
const queryYjSortData = async () => {
  try {
    const res = await yjsort();
    yjSortData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询业绩排名列表失败");
  }
};
const queryZfcgList = async (category: number) => {
  try {
    const res = await zfcgList({ category });
    data.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询招标采购列表失败");
  }
};
const queryZbcgList = async (category: string) => {
  try {
    const res = await zbcgList({ category });
    zbcgData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询招标采购列表失败");
  }
};
const queryZhcgList = async (category: string) => {
  try {
    const res = await zhcgList({ category });
    zhcgData.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询寻源快采列表失败");
    return;
  }
};
const querySpecialSearch = async () => {
  try {
    const res = await specialSearch({
      projectClassification: 3,
      domainId:
        process.env.VUE_APP_ENV === "production"
          ? "439729698164236288"
          : "93018945505746944",
      pageParam: { pageNum: 1, pageSize: 6 },
    });
    if (!res) {
      errorInfoDis("未查询到结果");
      return;
    }
    zhcgData.value = res.list || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询黄山徽投专区列表失败");
    return;
  }
};
// const queryZcfgList = async () => {
//   try {
//     const res = await newsListPage({
//       category: 4,
//       pageParam: { pageNum: 1, pageSize: 14 },
//     });
//     console.log(res, "dfdfdf");

//     if (!res) {
//       errorInfoDis("未查询到结果");
//       return;
//     }
//     zcfgData.value = res.list?.slice(0, 7) || [];
//     if (res?.list?.length > 7) {
//       hyzxData.value = res.list.slice(7) || [];
//     }
//   } catch (error: any) {
//     errorInfoDis(error.message || "查询政策法规列表失败");
//     return;
//   }
// };
const queryHyzxList = async () => {
  try {
    const res = await newsListPage({
      category: 5,
      pageParam: { pageNum: 1, pageSize: 14 },
    });
    if (!res) {
      errorInfoDis("未查询到结果");
      return;
    }
    zcfgData.value = res.list?.slice(0, 7) || [];
    if (res?.list?.length > 7) {
      hyzxData.value = res.list.slice(7) || [];
    }
  } catch (error: any) {
    errorInfoDis(error.message || "查询行业资讯列表失败");
    return;
  }
};
const runHelpCenter = (type: number) => {
  if (type === 1) {
    useRouteHopping("/common-problem");
  } else {
    useRouteHopping("/help-center");
  }
};
const jumpMedical = () => {
  window.open("https://ahtg.youzhicai.com/hospital/mainContent/home");
};
const selectZbKey = (key: string) => {
  queryZbcgList(key);
};
const selectZhcgKey = (key: string) => {
  if (key !== "11") {
    queryZhcgList(key);
  } else {
    // 获取黄山徽投专区数据
    querySpecialSearch();
  }
};
// 菜单角色权限列表
const menuRoleList = ref<any[]>([]);
// 查询当前登录人菜单权限
const queryMenuPermissionsByPath = async () => {
  try {
    const menuList = [
      "/project-manage/project",
      "/project-manage/simple/tender-project",
      "/supplier-library",
    ];
    const res = await getMenuPermissionsByPath({
      menuPaths: menuList,
    });
    menuRoleList.value = res || [];
  } catch (error: any) {
    errorInfoDis(error.message || "查询菜单权限失败");
  }
};

const getRoleTabKey = () => {
  const name = currentRoute.value.query.name;
  if (name) {
    searchVal.value = name as string;
  }
  if (userStore.userName) {
    queryMenuPermissionsByPath();
  }
  // 判断当前角色
  if (userStore.userRole.includes(3)) {
    roleTabKey.value = 1;
  } else if (userStore.userRole.includes(2) || userStore.userRole.includes(1)) {
    roleTabKey.value = 2;
  }
};
// 是否在顶部
const isAtTop = ref(true);
const checkScrollPosition = () => {
  isAtTop.value =
    (window.pageXOffset ||
      document.body.scrollTop ||
      document.documentElement.scrollTop) === 0;
};
onMounted(async () => {
  window.addEventListener("scroll", checkScrollPosition);
  setDocumentTitle("首页");
  queryBidCount();
  queryTendCount();
  queryProjectCount();
  queryAmountCount();
  queryZbcgList(activeKey.value);
  queryZfcgList(govKey.value);
  queryZhcgList(zhcgKey.value);
  queryActiveBidder();
  // queryZcfgList();
  queryHyzxList();
  queryYjSortData();
  getRoleTabKey();
  userStore.fetchUserInfo().finally(() => {
    getRoleTabKey();
  });
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", checkScrollPosition);
});

return (_ctx: any,_cache: any) => {
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(AppHeader, {
      type: isAtTop.value ? 'home' : ''
    }, null, 8, ["type"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_carousel, { autoplay: "" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_input, {
            size: "large",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(() => goSearchResult(), ["enter"])),
            value: _unref(searchVal),
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchVal) ? (searchVal).value = $event : null)),
            valueModifiers: { trim: true },
            class: "search-input-home",
            placeholder: "请输入项目名称、编号或通过发布单位进行搜索"
          }, {
            addonBefore: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_select, {
                  value: _unref(searchType),
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchType) ? (searchType).value = $event : null)),
                  class: "search-select",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("项目")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("发布单位")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_a_button, {
            size: "large",
            type: "primary",
            class: "search-btn",
            onClick: _cache[3] || (_cache[3] = () => goSearchResult())
          }, {
            icon: _withCtx(() => [
              _hoisted_12
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 搜索 ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: _normalizeClass(["btn", {
                  active: roleTabKey.value === 1,
                  disabled:
                    _unref(userStore).userName && !_unref(userStore).userRole.includes(3),
                }]),
                onClick: _cache[4] || (_cache[4] = () => changeLoginTab(1))
              }, " 投标人/供应商 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["btn btn-2", {
                  active: roleTabKey.value === 2,
                  disabled:
                    _unref(userStore).userName &&
                    !_unref(userStore).userRole.includes(1) &&
                    !_unref(userStore).userRole.includes(2),
                }]),
                onClick: _cache[5] || (_cache[5] = () => changeLoginTab(2))
              }, " 代理机构/采购人 ", 2)
            ]),
            (!_unref(userStore).userName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, _toDisplayString(getCurrentTimePeriod()) + " ~", 1),
                    _hoisted_20
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[6] || (_cache[6] = () => loginHandle()),
                      type: "primary",
                      class: "login-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 立即登录 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_button, {
                      onClick: _cache[7] || (_cache[7] = () => registerHandle()),
                      class: "register-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 免费注册 ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_27, "您好！" + _toDisplayString(_unref(userStore).userName), 1),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(userStore).subjectName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_a_button, {
                        onClick: _cache[8] || (_cache[8] = () => jumpUserManage()),
                        type: "primary",
                        class: "enter-btn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 进入用户管理平台 ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])),
            _createVNode(_component_a_row, { class: "tools-container" }, {
              default: _withCtx(() => [
                (roleTabKey.value === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_unref(userStore).userName)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", { onClick: downloadRegisterGuide }, "注册指南")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            onClick: jumpMyProject,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          })),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (jumpUserManage('3')))
                          }, " 大宗及零星采购 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", { onClick: jumpSupplierLibrary }, "供应商库管理")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      })
                    ], 64)),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (runHelpCenter(0)))
                    }, "常见问题")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (runHelpCenter(1)))
                    }, "帮助中心")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(projectCount)), 1),
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_unref(amountCount)), 1),
                _hoisted_38
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_unref(bidderCount)), 1),
                  _hoisted_39
                ]),
                _hoisted_40
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_41,
        _hoisted_42
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_tabs, {
                "tab-position": "right",
                activeKey: _unref(activeKey),
                "onUpdate:activeKey": _cache[12] || (_cache[12] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : null)),
                onChange: selectZbKey
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, { key: "1" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '1' }])
                      }, [
                        (_unref(activeKey) === '1')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                          : (_openBlock(), _createElementBlock("img", _hoisted_48)),
                        _createTextVNode(" 招标计划 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "11" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '11' }])
                      }, [
                        (_unref(activeKey) === '11')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                          : (_openBlock(), _createElementBlock("img", _hoisted_50)),
                        _createTextVNode(" 需求征集 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "12" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '12' }])
                      }, [
                        (_unref(activeKey) === '12')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_51))
                          : (_openBlock(), _createElementBlock("img", _hoisted_52)),
                        _createTextVNode(" 标前公示 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    "force-render": ""
                  }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '2' }])
                      }, [
                        (_unref(activeKey) === '2')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_53))
                          : (_openBlock(), _createElementBlock("img", _hoisted_54)),
                        _createTextVNode(" 招标公告 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "3" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '3' }])
                      }, [
                        (_unref(activeKey) === '3')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                          : (_openBlock(), _createElementBlock("img", _hoisted_56)),
                        _createTextVNode(" 澄清/变更公告 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "4" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '4' }])
                      }, [
                        (_unref(activeKey) === '4')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                          : (_openBlock(), _createElementBlock("img", _hoisted_58)),
                        _createTextVNode(" 中标候选人公示 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "5" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(activeKey) === '5' }])
                      }, [
                        (_unref(activeKey) === '5')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_59))
                          : (_openBlock(), _createElementBlock("img", _hoisted_60)),
                        _createTextVNode(" 中标结果公告 ")
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(zbcgData), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.sid,
                onClick: () => toDetail(item.sid)
              }, [
                (index < 6)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "zb-content-item",
                      style: _normalizeStyle(
                  index === _unref(zbcgData).length - 1 ? 'border-bottom:none' : ''
                )
                    }, [
                      (item.zoneName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("span", null, _toDisplayString(item.zoneName), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", {
                          title: item.title,
                          class: "title"
                        }, _toDisplayString(item.title), 9, _hoisted_65),
                        _createVNode(_component_a_row, {
                          align: "middle",
                          gutter: [16, 0]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              title: item.releaseUnity,
                              class: "company"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_66,
                                _createTextVNode(" " + _toDisplayString(item.releaseUnity), 1)
                              ]),
                              _: 2
                            }, 1032, ["title"]),
                            (item.endTime)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  class: "time"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("截止时间：" + _toDisplayString(item.endTime), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (item.startTime)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  class: "time"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("发布时间：" + _toDisplayString(item.startTime), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        (
                      item['durations'] && !['3', '4', '5'].includes(_unref(activeKey))
                    )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item['durations']['isOvertime'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, " 已截止 "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _createElementVNode("div", {
                                      class: "to-bid",
                                      onClick: _withModifiers(() => toToBidder(item), ["stop"])
                                    }, " 我要参与 ", 8, _hoisted_70),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createTextVNode(" 剩余: "),
                                      _createElementVNode("span", _hoisted_72, _toDisplayString(item["durations"]["days"]), 1),
                                      _createTextVNode("天 "),
                                      _createElementVNode("span", _hoisted_73, _toDisplayString(item["durations"]["hours"]), 1),
                                      _createTextVNode("时"),
                                      _createElementVNode("span", _hoisted_74, _toDisplayString(item["durations"]["minutes"]), 1),
                                      _createTextVNode("分 ")
                                    ])
                                  ]))
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createTextVNode(_toDisplayString(_unref(dayjs)(item.releaseTime).format("DD")) + " ", 1),
                                _hoisted_77
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(item.releaseTime).format("MM 月")), 1),
                                _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(item.releaseTime).format("YYYY")), 1)
                              ])
                            ]))
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_62))
            }), 128)),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("a", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (toSearch(1)))
              }, "查看更多 >")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _hoisted_81,
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createVNode(_component_a_carousel, {
            "dot-position": "left",
            autoplay: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_84, [
                _hoisted_85,
                _createElementVNode("div", {
                  title: text1,
                  class: "dec"
                }, _toDisplayString(text1)),
                _createVNode(_component_a_button, {
                  onClick: _cache[14] || (_cache[14] = () => loginHandle())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("立即体验")
                  ]),
                  _: 1
                }),
                _hoisted_86
              ]),
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", {
                  title: text2,
                  class: "dec"
                }, _toDisplayString(text2)),
                _createVNode(_component_a_button, { onClick: jumpMedical }, {
                  default: _withCtx(() => [
                    _createTextVNode("立即体验")
                  ]),
                  _: 1
                }),
                _hoisted_89,
                _hoisted_90
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_91, [
          _createVNode(_component_a_row, { gutter: [17, 17] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _hoisted_94,
                    _createVNode(_component_a_tooltip, {
                      placement: "bottom",
                      overlayClassName: "fuc-dec-tooltip"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(text3))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", { class: "fuc-dec" }, _toDisplayString(text3))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _hoisted_97,
                    _createVNode(_component_a_tooltip, {
                      placement: "bottom",
                      overlayClassName: "fuc-dec-tooltip"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(text4))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", { class: "fuc-dec" }, _toDisplayString(text4))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_98, [
                    _hoisted_99,
                    _hoisted_100,
                    _createVNode(_component_a_tooltip, {
                      placement: "bottom",
                      overlayClassName: "fuc-dec-tooltip"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(text5))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", { class: "fuc-dec" }, _toDisplayString(text5))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_101, [
                    _hoisted_102,
                    _hoisted_103,
                    _createVNode(_component_a_tooltip, {
                      placement: "bottom",
                      overlayClassName: "fuc-dec-tooltip"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(text6))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", { class: "fuc-dec" }, _toDisplayString(text6))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_104, [
      _createElementVNode("div", _hoisted_105, [
        _hoisted_106,
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-name", _unref(govKey) === 11 ? 'active' : '']),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (checkGovNav(11)))
          }, " 需求调查 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-name", _unref(govKey) === 2 ? 'active' : '']),
            onClick: _cache[16] || (_cache[16] = ($event: any) => (checkGovNav(2)))
          }, " 采购公告 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-name", _unref(govKey) === 3 ? 'active' : '']),
            title: "澄清/变更公告",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (checkGovNav(3)))
          }, " 澄清/变更公告 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-name", _unref(govKey) === 5 ? 'active' : '']),
            onClick: _cache[18] || (_cache[18] = ($event: any) => (checkGovNav(5)))
          }, " 结果公告 ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-name", _unref(govKey) === 9 ? 'active' : '']),
            onClick: _cache[19] || (_cache[19] = ($event: any) => (checkGovNav(9)))
          }, " 其他公告 ", 2)
        ]),
        _createVNode(_component_a_row, { gutter: [24, 16] }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                span: 8,
                key: index
              }, {
                default: _withCtx(() => [
                  (index < 12)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "zc-col",
                        onClick: () => toDetail(item.sid)
                      }, [
                        (item.zoneName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                              _createElementVNode("span", null, _toDisplayString(item.zoneName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          title: item.title,
                          class: "title"
                        }, _toDisplayString(item.title), 9, _hoisted_110),
                        (item['durations'] && !item['durations']['isOvertime'])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                              _createElementVNode("div", _hoisted_112, [
                                _createTextVNode(" 剩余: "),
                                _createElementVNode("span", null, _toDisplayString(item["durations"]["days"]), 1),
                                _createTextVNode(" 天 "),
                                _createElementVNode("span", _hoisted_113, _toDisplayString(item["durations"]["hours"]), 1),
                                _createTextVNode(" 时 "),
                                _createElementVNode("span", _hoisted_114, _toDisplayString(item["durations"]["minutes"]), 1),
                                _createTextVNode(" 分 ")
                              ]),
                              _createElementVNode("div", {
                                class: "button",
                                onClick: _withModifiers(() => toToBidder(item), ["stop"])
                              }, _hoisted_117, 8, _hoisted_115)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(item.startTime), 1))
                      ], 8, _hoisted_108))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("a", {
            onClick: _cache[20] || (_cache[20] = ($event: any) => (toSearch(2)))
          }, "查看更多 >")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_120, [
      _hoisted_121,
      _createElementVNode("div", _hoisted_122, [
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_tabs, {
                "tab-position": "right",
                activeKey: _unref(zhcgKey),
                "onUpdate:activeKey": _cache[21] || (_cache[21] = ($event: any) => (_isRef(zhcgKey) ? (zhcgKey).value = $event : null)),
                onChange: selectZhcgKey
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, { key: "2" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(zhcgKey) === '2' }])
                      }, [
                        (_unref(zhcgKey) === '2')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_125))
                          : (_openBlock(), _createElementBlock("img", _hoisted_126)),
                        _createTextVNode(" 采购公告 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    "force-render": ""
                  }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(zhcgKey) === '3' }])
                      }, [
                        (_unref(zhcgKey) === '3')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_127))
                          : (_openBlock(), _createElementBlock("img", _hoisted_128)),
                        _createTextVNode(" 澄清/变更公告 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    "force-render": ""
                  }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(zhcgKey) === '4' }])
                      }, [
                        (_unref(zhcgKey) === '4')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_129))
                          : (_openBlock(), _createElementBlock("img", _hoisted_130)),
                        _createTextVNode(" 候选人公示 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "5" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(zhcgKey) === '5' }])
                      }, [
                        (_unref(zhcgKey) === '5')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_131))
                          : (_openBlock(), _createElementBlock("img", _hoisted_132)),
                        _createTextVNode(" 结果公告 ")
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "9" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["tab-pane", { cur: _unref(zhcgKey) === '9' }])
                      }, [
                        (_unref(zhcgKey) === '9')
                          ? (_openBlock(), _createElementBlock("img", _hoisted_133))
                          : (_openBlock(), _createElementBlock("img", _hoisted_134)),
                        _createTextVNode(" 其他公告 ")
                      ], 2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ])
          ]),
          _createElementVNode("div", _hoisted_135, [
            _createVNode(_component_a_row, { gutter: [24, 16] }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(zhcgData), (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 8,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      (index < 12)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "zc-col",
                            onClick: () => toDetail(item.sid)
                          }, [
                            (item.zoneName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                  _createElementVNode("span", null, _toDisplayString(item.zoneName), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              title: item.title,
                              class: "title"
                            }, _toDisplayString(item.title), 9, _hoisted_138),
                            (item['durations'] && !item['durations']['isOvertime'])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                  _createElementVNode("div", _hoisted_140, [
                                    _hoisted_141,
                                    _createTextVNode(" 剩余: "),
                                    _createElementVNode("span", null, _toDisplayString(item["durations"]["days"]), 1),
                                    _createTextVNode(" 天 "),
                                    _createElementVNode("span", _hoisted_142, _toDisplayString(item["durations"]["hours"]), 1),
                                    _createTextVNode(" 时 "),
                                    _createElementVNode("span", _hoisted_143, _toDisplayString(item["durations"]["minutes"]), 1),
                                    _createTextVNode(" 分 ")
                                  ]),
                                  _createElementVNode("div", {
                                    class: "button",
                                    onClick: _withModifiers(() => toToBidder(item), ["stop"])
                                  }, _hoisted_146, 8, _hoisted_144)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(item.startTime), 1))
                          ], 8, _hoisted_136))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_148, [
              (+_unref(zhcgKey) !== 11)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (toSearch(3)))
                  }, "查看更多 >"))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _unref(companySiteUrl)
                  }, " 进入企业首页 ", 8, _hoisted_149))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_150, [
      _hoisted_151,
      _createElementVNode("div", _hoisted_152, [
        _createVNode(_component_a_row, { style: {"width":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              style: {"padding-right":"70px"},
              span: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("ul", _hoisted_154, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(zcfgData), (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.sid,
                          onClick: () => toDetailNews(`n_${item.sid}-1`)
                        }, [
                          _createElementVNode("div", {
                            title: item.title
                          }, _toDisplayString(item.title), 9, _hoisted_156),
                          _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(item.createTime).format("YYYY.MM.DD")), 1)
                        ], 8, _hoisted_155))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              style: {"padding-left":"70px"},
              span: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("ul", _hoisted_158, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hyzxData), (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.sid,
                          onClick: () => toDetailNews(`n_${item.sid}-1`)
                        }, [
                          _createElementVNode("div", {
                            title: item.title
                          }, _toDisplayString(item.title), 9, _hoisted_160),
                          _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(item.createTime).format("YYYY.MM.DD")), 1)
                        ], 8, _hoisted_159))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(ContactUs), {
      visible: _unref(contactVisible),
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => (_isRef(contactVisible) ? (contactVisible).value = $event : null))
    }, null, 8, ["visible"]),
    _createVNode(_unref(NoPermission), {
      visible: _unref(permissionVisible),
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => (_isRef(permissionVisible) ? (permissionVisible).value = $event : null))
    }, null, 8, ["visible"])
  ]))
}
}

})